import {UPDATE_SHIPMENT_DETAILS, CLEAR_NEW_LIABILITY_POLICY} from '../actions/types';

export const shipmentDetailsReducer = (state = {} , action) => {
    switch(action.type) {
        case UPDATE_SHIPMENT_DETAILS:
            return {...state, ...action.payload} || {};
        case CLEAR_NEW_LIABILITY_POLICY:
            return {};
            
        default:
            return state;
    }
}